import { Component, Host, h, Prop, Watch, Element, Event, EventEmitter } from '@stencil/core';

@Component({
    tag: 'sew-ws-tabs-item',
    styleUrl: 'sew-ws-tabs-item.scss',
    shadow: true,
})
export class SewWsTabsItem {
    @Element() host: HTMLSewWsTabsItemElement;

    @Prop() name: string;
    @Prop({ reflect: true }) active: boolean;
    @Prop() tabId: string;
    @Prop({ reflect: true }) buttonHref: string;

    @Event() activated: EventEmitter<string>;

    @Watch('active')
    watchActiveHandler(): void {
        if (this.active) {
            this.activated.emit(this.name);
        }
    }

    render() {
        return (
            <Host>
                <h4 class="print-headline" innerHTML={this.name}></h4>
                <slot></slot>
            </Host>
        );
    }
}
